<template>
  <mds-tag removable @mds-tag-removed="$emit('closeItem', label)">
    <strong>{{ type }}: </strong> {{ label }}
  </mds-tag>
</template>
<script>
import { MdsTag } from '@mds/tag';

export default {
  name: 'filterItem',
  components: {
    MdsTag,
  },
  data() {
    return {};
  },
  props: ['label', 'type'],
};
</script>
